export const EVENTS = {
  OPEN_TOOLTIP: "OPEN_TOOLTIP",
  CLOSE_TOOLTIP: "CLOSE_TOOLTIP",
  FETCH_DETAILS_STARTED: "FETCH_DETAILS_STARTED",
  FETCH_DETAILS_SUCCESS: "FETCH_DETAILS_SUCCESS",
  FETCH_DETAILS_FAILED: "FETCH_DETAILS_FAILED",
};

export const INITIAL_STATE = {
  tooltipOpen: false,
  tooltipApi: { loading: null, error: null },
  tooltipDetails: {
    id: 0,
    title: "",
    description: "",
    image: "",
    categories: [],
  },
};

export function highlighterReducer(state, action) {
  switch (action.type) {
    case EVENTS.OPEN_TOOLTIP:
      return { ...state, tooltipOpen: true };
    case EVENTS.CLOSE_TOOLTIP:
      return { ...state, tooltipOpen: false };
    case EVENTS.FETCH_DETAILS_STARTED: {
      return {
        ...state,
        tooltipApi: { error: false, loading: true },
      };
    }
    case EVENTS.FETCH_DETAILS_SUCCESS: {
      return {
        ...state,
        tooltipApi: { error: false, loading: false },
        tooltipDetails: { ...INITIAL_STATE.tooltipDetails, ...action.payload },
      };
    }
    case EVENTS.FETCH_DETAILS_FAILED: {
      return {
        ...state,
        tooltipApi: { error: true, loading: false },
      };
    }
    default:
      return { ...state };
  }
}
